import { render, staticRenderFns } from "./ImageFrame.vue?vue&type=template&id=0d6c6430&scoped=true"
import script from "./ImageFrame.vue?vue&type=script&lang=js"
export * from "./ImageFrame.vue?vue&type=script&lang=js"
import style0 from "./ImageFrame.vue?vue&type=style&index=0&id=0d6c6430&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6c6430",
  null
  
)

export default component.exports